































import {Component, Prop, Vue} from 'vue-property-decorator'
import {currency} from "@/util/formatter";
import {CombinedPlan, SubscriptionPlan} from "@/util/subscription";

@Component
export default class PricingOptionCard extends Vue {

    @Prop({
        default: false
    })
    isActivePlan!: boolean;

    @Prop({
        default: 'monthly'
    })
    activePricingOption: 'monthly' | 'yearly' = 'monthly';

    @Prop({
        default: null
    })
    combinedPlan?: CombinedPlan

    @Prop()
    pricingOption!: 'basic' | 'pro' | 'premium';

    private get planName(): string {
        switch (this.pricingOption) {
            case "basic":
                return 'Basic'
            case "pro":
                return 'Pro';
            case "premium":
                return 'Premium';
        }
    }

    private get formattedPrice(): string {
        const price = this.getActivePlan()!.price;
        const priceContainsFraction = (price - Math.floor(price)) !== 0;
        return currency(price, priceContainsFraction);
    }

    private getActivePlan(): SubscriptionPlan | undefined {
        if (this.activePricingOption === 'monthly') {
            return this.combinedPlan?.monthly
        } else {
            return this.combinedPlan?.yearly;
        }
    }

    private get userIsOnPlan(): boolean {
        return this.isActivePlan && this.isUserLoggedIn;
    }

    private get priceClass(): string {
        switch (this.pricingOption) {
            case "basic":
                return 'text-black-light'
            case "pro":
                return 'text-green';
            case "premium":
                return 'text-black-light';
        }
    }

    private get buttonClass(): string {
        switch (this.pricingOption) {
            case "basic":
                return ''
            case "pro":
                return 'positive';
            case "premium":
                return '';
        }
    }

    private get isUserLoggedIn(): boolean {
        return (window as any).USER_ID !== null;
    }

    private get canShowButton(): boolean {
        const isUserSubscribed = (window as any).IS_SUBSCRIBED;
        if (this.userIsOnPlan || isUserSubscribed) {
            return false;
        }

        return !isUserSubscribed;
    }

    private get buttonText(): string {
        return this.isUserLoggedIn ? 'Choose' : 'Sign up';
    }

    private get actionHref(): string {
        const activePlan = this.getActivePlan();
        if (activePlan) {
            return this.isUserLoggedIn ? `/subscription?plan_id=${activePlan.id}` : `/register?plan_id=${activePlan.id}`;
        } else {
            return '/pricing';
        }
    }

    private get features(): string[] {
        switch (this.pricingOption) {
            case "basic":
                return [
                    'Monthly or yearly payment option',
                    'View & Submit Tax Return',
                    'See your tax liability',
                ]
            case "pro":
                return [
                    'Monthly or yearly payment option',
                    'View & Submit Tax Return',
                    'See your tax liability',
                    'Performance Reports',
                    'Snap & Store receipts',
                    'Discounts & Benefits',
                    'Email Support'
                ]
            case "premium":
                return [
                    'Monthly or yearly payment option',
                    'View & Submit Tax Return',
                    'See your tax liability',
                    'Performance Reports',
                    'Snap & Store receipts',
                    'Discounts & Benefits',
                    'Email Support',
                    'Telephone Support',
                    'Tax Investigation Cover <em>(coming soon)</em>'
                ]
        }
    }

    private get disabledFeatures(): string[] {
        switch (this.pricingOption) {
            case "basic":
                return [
                    'Performance Reports',
                    'Snap & Store receipts',
                    'Discounts & Benefits',
                    'Email Support',
                    'Telephone Support',
                    'Tax Investigation Cover'
                ]
            case "pro":
                return [
                    'Telephone Support',
                    'Tax Investigation Cover'
                ]
            case "premium":
                return []
        }
    }
}
